import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-settings-credits-notification',
  templateUrl: './credits-notification.component.html'
})
export class CreditsNotificationComponent implements OnInit {
  @Output('UpdateOrganisationSettings') UpdateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  private _organisationSettings!: any;
  @Input('OrganisationSettings') set organisationSettings(val: any){
    val.EmailLowSigningValueReminderSchedule = (val.EmailLowSigningValueReminderSchedule == undefined || val.EmailLowSigningValueReminderSchedule == "") ? this.selectedLowSigningValueReminderSchedule : JSON.parse(val.EmailLowSigningValueReminderSchedule);
    this._organisationSettings = val;
  }
  get organisationSettings(): any {
    return this._organisationSettings;
  }
  selectedLowSigningValueReminderSchedule: string = "40";
  lowSigningPercentage: number[] = [10,20,30,40,50,60,70,80,90]

  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  updateValue(event: any) {
    let key: string = (event.target as HTMLInputElement).id;
    let hours: string = (event.target as HTMLInputElement).value;
    this.organisationSettings[key] = hours;
    this.UpdateOrganisationSettings.emit([{key:key, value:this.organisationSettings[key] }]);
  }
}
